import { Component } from '@angular/core';
import { BaseDatatableHeaderComponent } from '../base-datatable-header.component';
import { debounceTime, Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  template: `
    <app-input-icon
      icon="search"
      (inputChange)="onInputChange($event)"
      [placeholder]="this.colDef().custonConfig?.['placeholder'] ?? ''"
      [fullWidth]="true"
    />
  `,
})
export class InputIconHeaderComponent extends BaseDatatableHeaderComponent {
  private inputSubject = new Subject<string>();

  constructor() {
    super();

    this.inputSubject
      .pipe(takeUntilDestroyed())
      .pipe(debounceTime(500))
      .subscribe(value => {
        this.applyFilter(value);
      });
  }

  onInputChange(value: string) {
    this.inputSubject.next(value);
  }

  private applyFilter(value: string) {
    const keyFilter = this.colDef().custonConfig?.['keyFilter'];

    if (!keyFilter) throw new Error('Adicionar keyFilter em custonConfig.');

    this.onFilterChange()({ [keyFilter]: value });
  }
}
